module.exports = __webpack_public_path__ + "media/images/icons/outlined/menu-00756bba50acd8a52e98ad0f64731e98.svg";